import React from 'react';
import { Alert, Anchor, Spacer } from '@zillow/constellation';
import { useSelector } from 'react-redux';
import { screeningBrownoutMessageSelector } from '../../../selectors';
import { CUSTOMER_SUPPORT_LINK } from '../../../constants/urls';

export default function ScreeningBrownoutAlert() {
  const screeningBrownoutMessage = useSelector(screeningBrownoutMessageSelector);
  return (
    Boolean(screeningBrownoutMessage) && (
      <Spacer marginBottom="md">
        <Alert
          appearance="warning"
          body={
            <>
              Screening reports aren’t available right now. Please try again later. While you wait, you can continue
              reviewing other parts of applications. Contact{' '}
              <Anchor target="_blank" href={CUSTOMER_SUPPORT_LINK}>
                Customer Support
              </Anchor>{' '}
              if the issue persists.
            </>
          }
        />
      </Spacer>
    )
  );
}
